import React, { ReactNode } from "react"
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material"
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

type IPropsUiCollapsable = {
    name? : string,
    children: ReactNode,
    title: string | ReactNode
    number? : number,
}
export const UiCollapsable = (props: IPropsUiCollapsable) => {
    const cssClass = ['ui-collapsable']
    if(props.name){
        cssClass.push('ui-collapsable--'+props.name)
    }
    return(
        <Accordion defaultExpanded={true} className={cssClass.join(' ')} elevation={0}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
            >
                <h3>{props.title}</h3>
            </AccordionSummary>
            <AccordionDetails>
                <div className="box-fullwidth">
                {props.children}
                </div>
            </AccordionDetails>
        </Accordion>
    )
}

export default UiCollapsable;